import { render } from "./ContentSetting.vue?vue&type=template&id=258abe2d&scoped=true"
import script from "./ContentSetting.vue?vue&type=script&lang=js"
export * from "./ContentSetting.vue?vue&type=script&lang=js"

import "./ContentSetting.vue?vue&type=style&index=0&id=258abe2d&lang=scss&scoped=true"

import exportComponent from "C:\\programs\\dd2.0\\dw-dwms-mini\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258abe2d"]])

export default __exports__